module.exports = __webpack_public_path__ + "img/MirrorCut4.dc2aa477.png";